import React from 'react'
import { Button, Card, Empty } from 'antd'
import './mobile-empty-state.scss'

interface MobileEmptyStateAction {
    label: string
    onClick: () => void
    type?: 'primary' | 'default'
    icon?: React.ReactNode
}

interface MobileEmptyStateProps {
    /** Icon displayed above the description */
    icon: React.ReactNode
    /** Description text */
    description: string
    /** Optional secondary message below the description */
    message?: string
    /** Optional CTA button */
    action?: MobileEmptyStateAction
    /** When true, centers vertically in available space (for full-page error states) */
    fullPage?: boolean
    /** Additional class name on the outer wrapper */
    className?: string
}

/**
 * Unified empty/error/not-found state for mobile views.
 * Renders a Card with an antd Empty component inside.
 * Used across: notification list, draft list, notification detail, error boundary.
 */
export const MobileEmptyState: React.FC<MobileEmptyStateProps> = ({
    icon,
    description,
    message,
    action,
    fullPage = false,
    className,
}) => {
    const card = (
        <Card className={`mobile-empty-state ${className ?? ''}`} variant="borderless">
            <Empty image={icon} description={description}>
                {message && <p className="mobile-empty-state__message">{message}</p>}
                {action && (
                    <Button type={action.type ?? 'primary'} icon={action.icon} onClick={action.onClick}>
                        {action.label}
                    </Button>
                )}
            </Empty>
        </Card>
    )

    if (fullPage) {
        return <div className="mobile-empty-state__full-page">{card}</div>
    }

    return card
}
